import PartialPaymentsDrawer from './PartialPaymentsDrawer';

export default PartialPaymentsDrawer;
